import Airtable from 'airtable';

// Check if required environment variables are present
const hasRequiredEnvVars = Boolean(
  process.env.REACT_APP_AIRTABLE_TOKEN && 
  process.env.REACT_APP_AIRTABLE_BASE_ID
);

// Only initialize if we have the required variables
let base = null;
if (hasRequiredEnvVars) {
  try {
    const airtable = new Airtable({
      apiKey: process.env.REACT_APP_AIRTABLE_TOKEN
    });
    base = airtable.base(process.env.REACT_APP_AIRTABLE_BASE_ID);
    console.log('Airtable initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Airtable:', error);
  }
} else {
  console.error('Missing required environment variables for Airtable:', {
    hasApiKey: Boolean(process.env.REACT_APP_AIRTABLE_TOKEN),
    hasBaseId: Boolean(process.env.REACT_APP_AIRTABLE_BASE_ID)
  });
}

// Table names as constants to avoid string literals
export const TABLES = {
  FORM_SUBMISSIONS: 'WebsiteContactForm',
  BLOG_POSTS: 'BlogPosts', // This should match your Airtable table name exactly
  AI_ASSESSMENTS: 'AIReadinessAssessments',
};

// Field names as constants
export const FIELDS = {
  FORM_SUBMISSIONS: {
    NAME: 'Name',
    EMAIL: 'Email',
    COMPANY: 'Company',
    MESSAGE: 'Message',
    SERVICE_TYPE: 'Service Type',
    CURRENT_AI_SOLUTION: 'Current AI Solution',
    DEPLOYMENT_PREFERENCE: 'Deployment Preference',
    PROJECT_TIMELINE: 'Project Timeline',
    INDUSTRY_FOCUS: 'Industry Focus',
    SUBMISSION_DATE: 'Submission Date',
  },
  BLOG_POSTS: {
    TITLE: 'Title',
    SUBTITLE: 'Subtitle',
    CONTENT: 'Content',
    CATEGORY: 'Category',
    PUBLISH_DATE: 'PublishDate',
    READ_TIME: 'ReadTimeMinutes',
    TITLE_IMAGE: 'TitleImageUrl',
    AUTHOR: 'Author',
    SLUG: 'Slug',
    STATUS: 'Status',
    TAGS: 'Tags',
    SEO_DESCRIPTION: 'SEODescription',
    LAST_MODIFIED: 'LastModified',
    FEATURED: 'Featured'
  },
  AI_ASSESSMENTS: {
    SUBMISSION_ID: 'Submission ID',
    ASSESSMENT_DATE: 'Assessment Date',
    SUBMISSION_DATE: 'Submission Date',
    CONTACT_NAME: 'Contact Name',
    CONTACT_EMAIL: 'Contact Email',
    COMPANY_NAME: 'Company Name',
    COMPANY_SIZE: 'Company Size',
    INDUSTRY: 'Industry',
    ROLE: 'Role',
    CURRENT_AI_MATURITY_STAGE: 'Current AI Maturity Stage',
    CURRENT_AI_DESCRIPTION: 'Current AI Description',
    AI_USAGE_SCOPE: 'AI Usage Scope',
    EXECUTIVE_SUPPORT: 'Executive Support',
    SUCCESS_METRICS: 'Success Metrics',
    AI_STRATEGY: 'AI Strategy',
    BUSINESS_ALIGNMENT: 'Business Alignment',
    DEDICATED_ROLES: 'Dedicated Roles',
    TRAINING_PROGRAMS: 'Training Programs',
    CHANGE_MANAGEMENT: 'Change Management',
    CHANGE_READINESS: 'Change Readiness',
    STAFF_BURDEN_CONCERNS: 'Staff Burden Concerns',
    AI_LITERACY: 'AI Literacy',
    AI_TOOLS_IN_USE: 'AI Tools In Use',
    INTEGRATION_LEVEL: 'Integration Level',
    AUTOMATION_SCOPE: 'Automation Scope',
    CLOUD_PROVIDERS: 'Cloud Providers',
    ERP_SYSTEMS: 'ERP Systems',
    DEV_RESOURCES: 'Dev Resources',
    INFRASTRUCTURE_CONSTRAINTS: 'Infrastructure Constraints',
    DATA_QUALITY: 'Data Quality',
    DATA_ACCESSIBILITY: 'Data Accessibility',
    DATA_INVENTORY: 'Data Inventory',
    DATA_SECURITY: 'Data Security',
    STRUCTURED_VS_UNSTRUCTURED: 'Structured vs Unstructured',
    DATA_CLEANSING_NEEDED: 'Data Cleansing Needed',
    CLASSIFIED_DATA_HANDLING: 'Classified Data Handling',
    SECURITY_POSTURE: 'Security Posture',
    COMPLIANCE_REQUIREMENTS: 'Compliance Requirements',
    GOVERNANCE_FRAMEWORK: 'Governance Framework',
    ETHICAL_GUIDELINES: 'Ethical Guidelines',
    RISK_ASSESSMENT: 'Risk Assessment',
    ACCOUNTABILITY: 'Accountability',
    DATA_GOVERNANCE: 'Data Governance',
    DEPLOYMENT_PREFERENCE: 'Deployment Preference',
    BUDGET_ALLOCATED: 'Budget Allocated',
    TIMELINE: 'Timeline',
    TARGET_STAGE: 'Target Stage',
    PRIORITY_USE_CASES: 'Priority Use Cases',
    PRIMARY_GOALS: 'Primary Goals',
    BIGGEST_CHALLENGES: 'Biggest Challenges',
    ADDITIONAL_COMMENTS: 'Additional Comments',
    SUCCESS_DEFINITION: 'Success Definition',
    STRATEGY_SCORE: 'Strategy Score',
    GOVERNANCE_SCORE: 'Governance Score',
    PEOPLE_SCORE: 'People Score',
    TECHNOLOGY_SCORE: 'Technology Score',
    DATA_SCORE: 'Data Score',
    OVERALL_SCORE: 'Overall Score',
    RECOMMENDED_STAGE: 'Recommended Stage',
  }
};

// Debug logging for configuration
console.log('Airtable Configuration:', {
  hasRequiredEnvVars,
  baseInitialized: base !== null,
  blogTableName: TABLES.BLOG_POSTS,
  blogFields: FIELDS.BLOG_POSTS
});

export { base };
